(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["impact-sector-page"]) return;
  try {
    
function impactSectorEnquiry() {
  const form = document.querySelector('#ImpactContactForm');
  const page = document.querySelector('.ia-sector-page');
  const application = page?.dataset.impactApplication || '';
  if (!form || !application) return;
  const message = form.querySelector('#ImpactMessage');
  if (message && !message.value.trim()) message.value = application + '\n\n';
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', impactSectorEnquiry);
else impactSectorEnquiry();
document.addEventListener('shopify:section:load', impactSectorEnquiry);

  } catch(e) { console.error(e); }
})();
})();
